import React from 'react'

import { Box, Paper } from '@mui/material'
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material'

import { stikiStaticColors } from '../../redux/features/pages/welcomeStaticData'

// The box the account screens use for what someone needs to know first: a
// stiki's default khaki, with an info icon, as wide as the forms (400px).
// Links inside it should use `primary.dark`; the default link blue is too
// faint on khaki.
export default function NoticeBox({ children, sx }) {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 4,
        // The icon fills some of the left side, so less padding there keeps
        // the text looking centred.
        pl: 2,
        my: 2,
        width: '100%',
        maxWidth: 400,
        display: 'flex',
        gap: 1.5,
        backgroundColor: stikiStaticColors.khaki,
        ...sx,
      }}
    >
      <InfoOutlinedIcon sx={{ color: 'text.secondary', flexShrink: 0 }} />
      <Box sx={{ '& > :first-child': { mt: 0 }, '& > :last-child': { mb: 0 } }}>
        {children}
      </Box>
    </Paper>
  )
}
